'use client';

import React from 'react';
import clsx from 'clsx';
import Text from '@/components/Text/Text';
import Img from '../Img';
import styles from './HeroSideImage.module.scss';

interface Image {
  height: number,
  width: number,
  url: string
}

type HeroProps = {
  data: {
    label: string;
    image: Image;
    title: string;
    description?: string;
  };
  className?: string;
};

const HeroSideImage = ({ data, className = '' }: HeroProps) => (
  <section
    className={clsx(styles.hero, 'custom', className)}
  >
    <div className={clsx(styles.content, 'global-section')}>
      <div className={styles.textContainer}>
        {data.label && <p className={styles.tagline}>{data.label}</p>}
        <Text
          tag='h1'
          className={styles.title}
        >
          {data.title}
        </Text>
        {data?.description && (
          <p className={styles.description}>
            {data.description}
          </p>
        )}
      </div>
      {data?.image && (
        <Img
          className={styles.image}
          src={data.image.url}
          height={445}
          width={520}
        />
      )}
    </div>
  </section>
);

export default HeroSideImage;
